import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { initSentry } from '@/lib/sentry';
import { reportWebVitals } from '@/lib/webVitals';
import App from './App';
import './index.css';

// Initialize Sentry before React app
initSentry();

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

// Lazy + dev-only so devtools stay a devDependency and skip production bundles.
const ReactQueryDevtoolsLazy = import.meta.env.DEV
  ? lazy(async () => {
      const { ReactQueryDevtools } = await import('@tanstack/react-query-devtools');
      return {
        default: function Devtools() {
          return <ReactQueryDevtools initialIsOpen={false} />;
        },
      };
    })
  : null;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      {ReactQueryDevtoolsLazy ? (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsLazy />
        </Suspense>
      ) : null}
    </QueryClientProvider>
  </React.StrictMode>
);

// Report Web Vitals after app loads
reportWebVitals();